import { render, staticRenderFns } from "./addTextTemplate.vue?vue&type=template&id=1b5050ad&scoped=true"
import script from "./addTextTemplate.vue?vue&type=script&lang=js"
export * from "./addTextTemplate.vue?vue&type=script&lang=js"
import style0 from "./addTextTemplate.vue?vue&type=style&index=0&id=1b5050ad&prod&scoped=true&lang=css"
import style1 from "./addTextTemplate.vue?vue&type=style&index=1&id=1b5050ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5050ad",
  null
  
)

export default component.exports